import {Component, Input, OnInit} from '@angular/core';
import {TipoMonedaDTO} from '../../../models/dtos/TipoMonedaDTO';
import {TotalesCFEDTO} from '../../../models/dtos/TotalesCFEDTO';
import {AbstractControl, FormGroup} from '@angular/forms';
import {DatosInicioTotalesDTO} from '../../../models/dtos/datosInicio/DatosInicioTotalesDTO';
import {EmisionCfeService} from '../../services/emision-cfe.service';

export interface MontosIVA {
  name: string;
  value: number;
}


@Component
({
  selector: 'app-totales',
  templateUrl: './totales.component.html',
  styleUrls: ['./totales.component.scss']
})
export class TotalesComponent implements OnInit
{
  @Input()
  totalesCFEDTO: TotalesCFEDTO;

  @Input()
  datosInicioTotalesDTO: DatosInicioTotalesDTO;

  @Input()
  parentFormGroup: FormGroup;

  montoTotal = '';
  lastMontoTotal = 0;

  displayedColumns: string[] = ['montoIVAMinimo', 'montoIVABasico', 'montoIVASuspenso'];
  habilitarRedondeoMontoTotal = true;

  emisorEsLiteralE;

  constructor(private emisionCfeService: EmisionCfeService)
  {

  }

  ngOnInit()
  {
    this.emisorEsLiteralE = this.emisionCfeService.getEmisorCFEDTO().esLiteralE;
  }

  get tipoMonedaControl(): AbstractControl
  {
    return this.parentFormGroup.get('tipoMonedaControl');
  }

  get tipoCambioControl(): AbstractControl
  {
    return this.parentFormGroup.get('tipoCambioControl');
  }

  get subtotalControl(): AbstractControl
  {
    return this.parentFormGroup.get('subtotalControl');
  }

  get montoIVAControl(): AbstractControl
  {
    return this.parentFormGroup.get('montoIVAControl');
  }

  get montoTotalControl(): AbstractControl
  {
    return this.parentFormGroup.get('montoTotalControl');
  }

  get cantidadLineasDetallesControl(): AbstractControl
  {
    return this.parentFormGroup.get('cantidadLineasDetallesControl');
  }

  get montoTotalRetenidoEResgControl(): AbstractControl
  {
    return this.parentFormGroup.get('montoTotalRetenidoEResgControl');
  }

  get montoTotalCreditoFiscalEResgControl(): AbstractControl
  {
    return this.parentFormGroup.get('montoTotalCreditoFiscalEResgControl');
  }

  public hayControlError(control: AbstractControl): boolean
  {
    return (control.invalid && (control.dirty || control.touched) && control.errors.required);
  }

  public onTipoMonedaChange(): void
  {
    this.totalesCFEDTO.tipoMoneda = this.obtenerTipoMoneda(this.datosInicioTotalesDTO.codigoTipoMonedaSeleccionado);

    if (this.datosInicioTotalesDTO.codigoTipoMonedaSeleccionado === 'USD')
    {
      this.datosInicioTotalesDTO.estaHabilitadoTipoCambio = true;
      this.totalesCFEDTO.tipoCambio = null;
      this.habilitarRedondeoMontoTotal = false;
      this.totalesCFEDTO.montoTotal = this.lastMontoTotal;
      this.montoTotal = this.lastMontoTotal.toFixed(2);
    }
    else
    {
      this.datosInicioTotalesDTO.estaHabilitadoTipoCambio = false;
      this.totalesCFEDTO.tipoCambio = 1;
      this.habilitarRedondeoMontoTotal = true;
    }
  }

  private obtenerTipoMoneda(codigoTipoMoneda: string): TipoMonedaDTO
  {
    let tipoMonedaARetornarDTO: TipoMonedaDTO = null;
    for (const tipoMonedaDTO of this.datosInicioTotalesDTO.tiposMonedasDTOs)
    {
      if (tipoMonedaDTO.codigo === codigoTipoMoneda)
      {
        tipoMonedaARetornarDTO = tipoMonedaDTO;
        break;
      }
    }

    return tipoMonedaARetornarDTO;
  }

  changeCheckedState(event: any) {
    if (this.totalesCFEDTO.montoTotal != null) {
      if (event) {
        this.totalesCFEDTO.montoTotal = this.round(this.totalesCFEDTO.montoTotal);
        this.montoTotal = this.round(this.totalesCFEDTO.montoTotal).toFixed(2);
      } else {
        this.totalesCFEDTO.montoTotal = this.lastMontoTotal;
        this.montoTotal = this.lastMontoTotal.toFixed(2);
      }
    }
  }

  round(valor: number): number {
    const decimales = valor - Math.floor(valor);
    let redondeado: number;
    if (decimales <= 0.5) {
      redondeado = Math.floor(valor);
    } else {
      redondeado = Math.ceil(valor);
    }
    return redondeado;
  }

  updateMontoTotal() {
    this.lastMontoTotal = this.totalesCFEDTO.montoTotal;
    this.montoTotal = this.totalesCFEDTO.montoTotal.toFixed(2);
  }

  obtenerMonto(value: number): string {
    if (this.totalesCFEDTO.montoTotal == null) {
      this.montoTotal = null;
    }
    if (value) {
      this.montoIVAControl.setErrors(null);
      this.montoTotalControl.setErrors(null);
      this.subtotalControl.setErrors(null);
      return value.toFixed(2);
    } else {
      return '';
    }
  }
}
